import styled from "styled-components";
import { theme } from "../../../styles/theme";

type IProps = {
  isRegister: boolean;
};

export const Label = styled.label<IProps>`
  position: absolute;
  top: -10px;
  left: 20px;
  z-index: 1;
  padding: 0 5px;

  font-style: normal;
  font-weight: ${theme.font.normal};
  font-size: 11px;
  font-family: ${theme.font.poppins};
  letter-spacing: -0.02em;
  color: ${theme.colors.gray300};
  background-color: ${({ isRegister }) =>
    isRegister ? theme.colors.darkBlue : theme.colors.blue900};

  & > span {
    font-family: ${theme.font.poppins};
    font-weight: ${theme.font.normal};
    font-size: 14px;
    letter-spacing: -0.02em;
    color: ${theme.colors.erro};
  }

  @media (min-width: 768px) {
    font-size: 12px;
  }
`;
